import React, { useState } from 'react';
import './DisclaimerModal.css';

const ACCOUNT_API = 'https://563t3yrmw5d42zyd7gw6eeeun40htlid.lambda-url.us-east-1.on.aws';

function DisclaimerModal({ onAccept, user }) {
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAccept = async () => {
    if (!agreed) return;
    setLoading(true);
    
    try {
      const token = localStorage.getItem('idToken');
      await fetch(`${ACCOUNT_API}/api/account/disclaimer`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {}
      });
      onAccept();
    } catch (e) {
      console.error('Disclaimer error:', e);
      onAccept(); // Still allow access
    }
    setLoading(false);
  };

  return (
    <div className="disclaimer-overlay">
      <div className="disclaimer-modal">
        <h2>📜 Terms of Use & Disclaimer</h2>
        
        <div className="disclaimer-content">
          <p>By using BetPilot AI, you acknowledge and agree:</p>
          
          <div className="disclaimer-section">
            <h4>1. FOR ENTERTAINMENT ONLY</h4>
            <p>BetPilot AI provides sports betting analysis for entertainment and informational purposes only. We do not guarantee any outcomes.</p>
          </div>
          
          <div className="disclaimer-section">
            <h4>2. NOT FINANCIAL ADVICE</h4>
            <p>Nothing on this platform constitutes financial, investment, or gambling advice. All betting decisions are your own responsibility.</p>
          </div>
          
          <div className="disclaimer-section">
            <h4>3. GAMBLING RISKS</h4>
            <p>Sports betting involves significant risk of financial loss. Never bet more than you can afford to lose. If you have a gambling problem, please contact <strong>1-800-GAMBLER</strong>.</p>
          </div>
          
          <div className="disclaimer-section">
            <h4>4. AGE REQUIREMENT</h4>
            <p>You must be 21+ years old (or legal gambling age in your jurisdiction) to use this platform.</p>
          </div>
          
          <div className="disclaimer-section">
            <h4>5. LEGAL COMPLIANCE</h4>
            <p>You are responsible for ensuring sports betting is legal in your jurisdiction. BetPilot AI does not facilitate actual bets.</p>
          </div>
          
          <div className="disclaimer-section">
            <h4>6. NO GUARANTEES</h4>
            <p>Past performance of AI models does not guarantee future results. Win rates and ROI figures are historical and may not continue.</p>
          </div>
          
          <div className="disclaimer-section">
            <h4>7. DATA ACCURACY</h4>
            <p>While we strive for accuracy, odds and game information may contain errors. Always verify with your sportsbook.</p>
          </div>
        </div>
        
        <div className="disclaimer-footer">
          <label className="agree-checkbox">
            <input 
              type="checkbox" 
              checked={agreed} 
              onChange={e => setAgreed(e.target.checked)} 
            />
            <span>I have read, understood, and agree to these terms</span>
          </label>
          
          <button 
            className="accept-btn" 
            onClick={handleAccept}
            disabled={!agreed || loading}
          >
            {loading ? 'Processing...' : 'I Agree - Continue'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DisclaimerModal;
